import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-list-toggle',
    templateUrl: './list-toggle.component.html',
    styleUrls: ['./list-toggle.component.scss'],
    standalone: false
})
export class ListToggleComponent implements OnInit {
  @Input()
  cardViewUrl!: string;

  @Input()
  listViewUrl!: string;

  @Input()
  isCardView!: boolean;

  @Input()
  isCardViewDisabled!: boolean;

  @Input()
  isListViewRouterLink!: boolean;

  @Input()
  isCardViewRouterLink!: boolean;

  ngOnInit(): void {
    if (!this.cardViewUrl) {
      throw new Error('cardViewUrl is required');
    }
    if (!this.listViewUrl) {
      throw new Error('listViewUrl is required');
    }
    if (this.isCardView === undefined) {
      throw new Error('isCardView is required');
    }
  }
}
